import { render } from "./detailUser.vue?vue&type=template&id=04ad0856"
import script from "./detailUser.vue?vue&type=script&lang=js"
export * from "./detailUser.vue?vue&type=script&lang=js"

import "./detailUser.vue?vue&type=style&index=0&id=04ad0856&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__